import script from "./ProductsListPage.vue?vue&type=script&lang=ts&setup=true"
export * from "./ProductsListPage.vue?vue&type=script&lang=ts&setup=true"

import "./ProductsListPage.vue?vue&type=style&index=0&id=5d99a785&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5d99a785"]])

export default __exports__